(ns app.front.view.workspace.related-workspace
  (:require [app.domain.application.model :as app-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.process :as process]
            [app.front.ui.actions :as ui-actions]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.ui.typography :refer [h3]]
            [app.front.ui.updated :as ui-updated]
            [app.front.util :as futil]
            [app.front.view.workspace.subs :as ws-subs]
            [app.front.view.workspace.util :as ws-util]
            [clojure.string :as str]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]))

(defn workspace-id-col [tr lang workspace]
  [:div.flex.flex-col.pr-4
   [h3 "font-bold mb-2"
    (->> [(or (config-model/category-name workspace lang)
              (tr [(:workspace/permit-type workspace)]))
          (some-> (workspace-model/workspace-application workspace)
                  (app-model/work-target-name lang))]
         (filter some?)
         (str/join " - "))]
   [:span
    (futil/str-and-desc
      (when (:workspace/category-group-config workspace)
        ;; do not show permit-type twice when no category
        (tr [(:workspace/permit-type workspace)]))
      (or (:workspace/municipal-case-id workspace)
          (:workspace/id workspace)))]])

(defn state-and-update-col [tr workspace]
  [:div.flex.flex-col
   [:span.uppercase.mb-2 (ws-util/workspace-state
                           tr
                           {:workspace-state (:domain/state workspace)
                            :phase-state     (-> workspace
                                                 workspace-model/workspace-target
                                                 :domain/state)})]
   [ui-updated/updated (->> workspace
                            :entity/_parent
                            (map :latest-change)
                            (sort-by :ts)
                            last)]])


#_{:clj-kondo/ignore [:used-underscored-binding]}
(defn related-workspaces-section [{{:workspace/keys [related-workspaces
                                                     _related-workspaces]} :workspace
                                   :keys                                   [target-id]}]
  (when-let [workspaces (->> (concat related-workspaces _related-workspaces)
                             (filter some?) ;; drop those we don't have view rights to
                             (sort-by :workspace/id)
                             seq)]
    (let [tr                      (<sub [::ws-subs/tr])
          lang                    (<sub [:language])
          removable-workspace-ids (->> related-workspaces
                                       (map :workspace/id)
                                       set)]
      [section/section
       :related-workspaces
       (util/mmap
         {:heading-button [ui-actions/primary-signal-button
                           (util/mmap
                             {:signal-id   :process.signal/link-existing-workspace
                              :button-opts {:kind :ghost}}
                             tr target-id)
                           (tr [:related-workspace/add-links])]}
         tr)
       (tr [:workspace/related-workspaces])
       [ui-table/modern-responsive-table
        {:items        workspaces
         :headerless?  true
         :tr           tr
         :link         {:description ws-util/workspace-link-description
                        :make-href   ws-util/workspace-or-resume-application-href}
         :make-actions (when (<sub [::process/signal-permitted?
                                    target-id
                                    [:process.signal/unlink-related-workspace]])
                         (fn [workspace]
                           [(let [workspace-id (:workspace/id workspace)
                                  signal       [:process.signal/unlink-related-workspace
                                                {:other-workspace-ids #{workspace-id}}]]
                              (when (and (<sub [::process/signal-permitted?
                                                target-id
                                                signal])
                                         (contains? removable-workspace-ids workspace-id))
                                {:title    (tr [:related-workspace/remove-link])
                                 :on-click #(>evt [::process/signal target-id signal])
                                 :icon     i/trash}))]))
         :cols         [[nil
                         (partial workspace-id-col tr lang)
                         {}]
                        [nil
                         :workspace/address
                         {:width "25%"}]
                        [nil
                         (partial state-and-update-col tr)
                         {:width "275px"}]]}]])))
